import assetPath from '/app/xinglets/jobs/domain/job-details/lo-matching-banner/src/assets/LO_summary_Eng.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')